import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LogoFull } from "@/components/core/Logo";
import { api, errMsg } from "@/lib/api";

export const AuthShell = ({ children }) => (
  <div className="min-h-screen bg-[#7CC6FA] flex flex-col items-center justify-center px-6 py-12">
    <LogoFull className="w-[320px] mb-10" />
    <div className="w-full max-w-md bg-[#8FD0FB] border border-[#5FB3EA] rounded-3xl p-10 shadow-[0_24px_60px_rgba(10,17,40,0.15)] core-rise">{children}</div>
  </div>
);

export default function ForgotPasswordPage() {
  const [identifier, setIdentifier] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try { const r = await api.post("/auth/forgot-password", { identifier: identifier.trim() }); setMsg(r.data.message); }
    catch (err) { setError(errMsg(err)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell>
      <Link to="/login" className="inline-flex items-center gap-1.5 text-sm font-bold text-[#0A1128] hover:text-[#E8173A] mb-5" data-testid="forgot-back-link"><ArrowLeft className="h-4 w-4" />Torna al login</Link>
      <h2 className="font-display text-3xl font-extrabold text-[#0A1128]">Password dimenticata?</h2>
      {msg ? (
        <div className="mt-6 rounded-xl border border-[#5FB3EA] bg-[#A6DAFC] p-4 text-sm font-semibold text-[#0A1128] flex gap-3" data-testid="forgot-success">
          <MailCheck className="h-5 w-5 shrink-0 text-[#E8173A]" />{msg}
        </div>
      ) : (
        <form onSubmit={submit} className="mt-2" data-testid="forgot-form">
          <p className="text-sm text-slate-500 mb-6">Inserisci la tua email o il tuo username: ti invieremo un link per scegliere una nuova password.</p>
          <div className="space-y-1.5">
            <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">Email o username</Label>
            <Input required autoCapitalize="none" value={identifier} onChange={(e) => setIdentifier(e.target.value)} className="h-12 rounded-xl" data-testid="forgot-identifier-input" />
          </div>
          {error && <div className="mt-4 text-sm font-semibold text-[#C8102E] bg-red-50 border border-red-200 rounded-xl px-4 py-3" data-testid="forgot-error">{error}</div>}
          <button type="submit" disabled={loading} className="mt-6 w-full h-12 rounded-full bg-[#0A1128] hover:bg-[#E8173A] text-white font-bold flex items-center justify-center transition-colors disabled:opacity-70" data-testid="forgot-submit-button">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Invia link di reimpostazione"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
